import {useEffect} from "react";

export function useClickOutside({ref, setOutside}) {
    useEffect(() => {
        if (!ref) return;
        const handleClickOutside = (event) => {
            // Kiểm tra nếu nhấp chuột nằm ngoài `ref`
            if (
                ref.current &&
                !ref.current.contains(event.target)
            ) {
                setOutside(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
}